import React from "react";
import { safeLocalFormat } from "../../../utilities/functions";

const LocalDateStart = ({ row }) => {
  return (
    <div>
      <div>
        {row.startDate ? (
          <>{safeLocalFormat(row?.startDate)}</>
        ) : (
          <>not specific</>
        )}
      </div>
    </div>
  );
};

export default LocalDateStart;
